import { useState } from 'react'
import { DeviceMobile } from '@phosphor-icons/react'
import { Button, Card } from '@/ui'
import { useI18n } from '@/i18n'
import { useInstallPrompt } from './useInstallPrompt'

const DISMISS_KEY = 'ucsc.install.dismissed'

export function InstallBanner() {
  const { t } = useI18n()
  const { canInstall, install } = useInstallPrompt()
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1'
    } catch {
      return false
    }
  })
  if (!canInstall || dismissed) return null

  return (
    <Card className="flex items-center gap-3 border-amber/40 bg-amber-wash px-3 py-3">
      <DeviceMobile size={28} className="shrink-0 text-amber-dark" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <div className="text-[14px] font-semibold text-ink">{t('pwa.installTitle')}</div>
        <div className="text-[13px] text-muted">{t('pwa.installBody')}</div>
      </div>
      <div className="flex shrink-0 flex-col gap-1">
        <Button size="sm" variant="accent" onClick={() => void install()}>
          {t('pwa.installAction')}
        </Button>
        <button
          type="button"
          className="text-[12px] text-muted underline"
          onClick={() => {
            setDismissed(true)
            try {
              localStorage.setItem(DISMISS_KEY, '1')
            } catch {
              /* ignore */
            }
          }}
        >
          {t('common.close')}
        </button>
      </div>
    </Card>
  )
}
